import { render, staticRenderFns } from "./ProductView.vue?vue&type=template&id=d2b28186&scoped=true"
import script from "./ProductView.vue?vue&type=script&lang=js"
export * from "./ProductView.vue?vue&type=script&lang=js"
import style0 from "./ProductView.vue?vue&type=style&index=0&id=d2b28186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b28186",
  null
  
)

export default component.exports